import OpenChallengePage from './OpenChallengePage';

const OpenTaskPage = () => <OpenChallengePage asTask />;

export default OpenTaskPage;
